import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import RankingModal from "../Components/Modals/RankingComponents/RankingModal";
import MyTablesModal from "../Components/Modals/MyTablesModal";

type Props = NativeStackScreenProps<RootStackParamList, "MyTables">;

const MyTablesScreen: React.FC<Props> = ({ navigation }) => {
  return <MyTablesModal onClose={() => navigation.goBack()} />;
};

export default MyTablesScreen;
